import { render, staticRenderFns } from "./NewCourier.vue?vue&type=template&id=b9fe8298"
import script from "./NewCourier.vue?vue&type=script&lang=js"
export * from "./NewCourier.vue?vue&type=script&lang=js"
import style0 from "./NewCourier.vue?vue&type=style&index=0&id=b9fe8298&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports